/**
 * Compact inline error indicator — full message appears on hover or keyboard focus.
 * @param {{ message?: string | null, className?: string }} props
 */
export function ErrorTooltip({ message, className = '' }) {
  if (!message) {
    return null;
  }

  return (
    <span
      className={`error-tooltip${className ? ` ${className}` : ''}`}
      tabIndex={0}
      role="img"
      aria-label={message}
    >
      <svg className="error-tooltip__icon" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path
          fillRule="evenodd"
          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-4a1 1 0 00-1 1v4a1 1 0 102 0V7a1 1 0 00-1-1zm0 8a1 1 0 100-2 1 1 0 000 2z"
          clipRule="evenodd"
        />
      </svg>
      <span className="error-tooltip__popup" role="tooltip">
        {message}
      </span>
    </span>
  );
}
